"use strict";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isObject = require('is-plain-object');

var _require = require('./constants'),
    TIMESTAMP_REGISTRAR_KEY = _require.TIMESTAMP_REGISTRAR_KEY;

function getTimestampState(state) {
  return state[TIMESTAMP_REGISTRAR_KEY];
}

function combineReducersR(combine) {
  return function (reducers) {
    reducers[TIMESTAMP_REGISTRAR_KEY] = function () {
      return {};
    };

    var prevState;
    var timestampRegistrar = createTimestampRegistrar();

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var combinedReducers = combine.apply(void 0, [reducers].concat(args));
    return function (state, action) {
      var nextState = combinedReducers(state, action);

      if (prevState) {
        for (var key in prevState) {
          timestampRegistrar.mark(key, prevState[key] !== nextState[key]);
        }
      } else {
        for (var _key2 in nextState) {
          timestampRegistrar.mark(_key2);
        }
      }

      nextState[TIMESTAMP_REGISTRAR_KEY] = timestampRegistrar.getTimestamps();
      prevState = nextState;
      return nextState;
    };
  };
}

function getTimestamp() {
  return Date.now() + Math.random() * 100;
}

function createTimestampRegistrar() {
  var timestampStore = {};

  function mark(reducerName, addNewTimestamp) {
    if (reducerName === TIMESTAMP_REGISTRAR_KEY) {
      return;
    }

    if (!timestampStore[reducerName] || addNewTimestamp) {
      var rTimestamp = getTimestamp();
      timestampStore[reducerName] = rTimestamp;
    }
  }

  function getTimestamps() {
    return _objectSpread({}, timestampStore);
  }

  return {
    mark: mark,
    getTimestamps: getTimestamps
  };
}
/* used when some inner state object (post, comment, category) is updated */


function markWithTimestamp(stateObject) {
  stateObject.rTimestamp = getTimestamp();
  return stateObject;
}
/* receives state returns { state, diff, prevState }
   state - same state just without top level timestamps
   diff - path of state that have changed

   If inner leaf doesn't have rTimestamp it considered as changed
*/


function createStateReceiver() {
  var prevState;
  var outerPrevState; // this is for passing it as a result

  return function (state) {
    var partialState = {}; // TODO add test for partial state

    var diff = [];

    if (!prevState) {
      diff = Object.keys(state).filter(function (k) {
        return k !== TIMESTAMP_REGISTRAR_KEY;
      }).map(function (k) {
        return [k];
      });
      partialState = state;
    } else {
      var _loop = function _loop(reducerName) {
        if (reducerName === TIMESTAMP_REGISTRAR_KEY) {
          return "continue";
        }

        var objectDiff = [];

        if (prevState[TIMESTAMP_REGISTRAR_KEY][reducerName] !== state[TIMESTAMP_REGISTRAR_KEY][reducerName]) {
          // check diff of top level reducers
          var reducerValue = state[reducerName];
          var isReducerObject = isObject(reducerValue) && isObject(prevState[reducerName]);

          if (isReducerObject) {
            var prevStateReducerKeys = Object.keys(prevState[reducerName]);
            var reducerKeys = Object.keys(reducerValue);
            var hasKeysInReducerChanged = reducerKeys.length !== prevStateReducerKeys.length || reducerKeys.some(function (k) {
              return !prevStateReducerKeys.includes(k);
            }); // new key in state, we don't want to show diffs per item in this case

            if (!hasKeysInReducerChanged) {
              for (var key in reducerValue) {
                // check diff of reducers items, if it's an object. Only one level deep
                if (!reducerValue[key]) {
                  break;
                } else if (!reducerValue[key].rTimestamp) {
                  break;
                } else if (prevState[reducerName][key] && prevState[reducerName][key].rTimestamp !== reducerValue[key].rTimestamp) {
                  objectDiff.push(key);
                }
              }
            }
          }

          if (objectDiff.length > 0) {
            var _diff;

            (_diff = diff).push.apply(_diff, objectDiff.map(function (d) {
              return [reducerName, d];
            }));

            partialState[reducerName] = partialState[reducerName] || {};

            for (var _iterator = _createForOfIteratorHelperLoose(objectDiff), _step; !(_step = _iterator()).done;) {
              var objKey = _step.value;
              partialState[reducerName][objKey] = state[reducerName][objKey];
            }
          } else {
            diff.push([reducerName]);
            partialState[reducerName] = state[reducerName];
          }
        }
      };

      for (var reducerName in prevState) {
        var _ret = _loop(reducerName);

        if (_ret === "continue") continue;
      }
    }

    outerPrevState = prevState;
    prevState = state;
    return {
      state: state,
      diff: diff,
      partialState: partialState,
      prevState: outerPrevState
    };
  };
}

module.exports = {
  combineReducersR: combineReducersR,
  markWithTimestamp: markWithTimestamp,
  createStateReceiver: createStateReceiver,
  getTimestampState: getTimestampState,
  TIMESTAMP_REGISTRAR_KEY: TIMESTAMP_REGISTRAR_KEY
};